import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Form, Row } from 'antd';
import { FormField, Upload } from 'components';
import { useForm } from 'antd/lib/form/Form';
import { ReactComponent as DownloadFile } from 'assets/icons/download_blue.svg';
import {
  content,
  content_only_kindergarten,
  content_optional,
  content_pea,
  formFields,
  formFields2,
} from './content';
import NoResults from 'pages/appTrack/page1/components/NoResults';
import { isAuditor, isBeneficiary, isCommittee, isProvider } from 'utils';
import { downloadApplicationZip, updateFormField } from 'store/forms/actions';
import { omit } from 'lodash';
import { flattenDocs } from '../../utils';
import { DownloadedItems } from '../../components/index';

const DocsInvestor = ({ group }) => {
  const [form] = useForm();
  const user = useSelector(state => state.user);
  const dispatch = useDispatch();
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const viewMode = isViewMode || !isBeneficiary(user?.groups);
  const schoolGrade = useSelector(state => state.forms.carrier.schoolGrade);
  const businessKey = useSelector(state => state.forms.businessKey);
  const documents = useSelector(state => state.forms.documents);
  const flatDocs = flattenDocs(documents);

  const kindergarten = schoolGrade == 'Παιδικός Σταθμός';

  const handleChange = ({ key, type, event }) => {
    // console.log({ key, type, event });
    let newValue;
    if (type === 'text' || type === 'textarea' || type === 'radio') {
      newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString();
    } else if (type === 'checkbox') {
      newValue = event.target.checked;
    } else if (
      type === 'formattedNumber' ||
      type === 'formattedNumberWithNegative'
    ) {
      newValue = parseFloat(
        event.target.value.replaceAll('.', '').replaceAll(',', '.')
      );
    } else if (
      type === 'select' ||
      type === 'number' ||
      type === 'numberWithDecimals'
    ) {
      newValue = event;
    }

    dispatch(
      updateFormField({
        group: 'documents',
        key,
        value: newValue,
      })
    );
  };

  const handleMassDownloadZip = async () => {
    if (!businessKey) {
      console.warn('Business key missing. Cannot download ZIP.');
      return;
    }
    try {
      dispatch(downloadApplicationZip(businessKey));
      console.log('ZIP download triggered!');
    } catch (err) {
      console.error('Failed to download ZIP:', err);
    }
  };

  const canMassDownload = isCommittee(user?.groups) || isAuditor(user?.groups);
  return (
    <div>
      {
        <Form
          form={form}
          initialValues={{
            ...documents,
          }}
          trigger="onChange"
        >
          {
            <>
              {!viewMode ? (
                content.map((item, index) => (
                  <Upload
                    item={item}
                    subFileCode={item.fileCode}
                    key={'docs' + index}
                    group={'documents'}
                  />
                ))
              ) : (
                <>
                  {canMassDownload && (
                    <div
                      className="mass-download-wrapper"
                      style={{
                        marginBottom: 16,
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <a
                        className="application-download-file-text"
                        onClick={e => {
                          e.preventDefault();
                          handleMassDownloadZip();
                        }}
                      >
                        <DownloadFile /> Download All Files
                      </a>
                    </div>
                  )}
                  <DownloadedItems content={content} docs={flatDocs} />
                </>
              )}
              {/* {kindergarten && 
                  content_only_kindergarten.map((item, index) => (
                    <Upload item={item} key={"docs"+index} group={group} />
                  ))} */}
              <div className="mt-3">
                <Row
                  justify="flex-start"
                  align="middle"
                  gutter={{ xs: 4, sm: 8, md: 12, lg: 16 }}
                >
                  <Col span={24}>
                    {!viewMode ? (
                      content_pea.map((item, index) => (
                        <Upload
                          item={item}
                          subFileCode={item.fileCode}
                          key={'docs' + index}
                          group={group}
                        />
                      ))
                    ) : (
                      <div className="mt-2">
                        <DownloadedItems
                          content={content_pea}
                          docs={flatDocs}
                        />
                      </div>
                    )}
                  </Col>

                  <Col span={24} className="gutter-row">
                    <Row
                      className="mt-3"
                      gutter={{ xs: 4, sm: 8, md: 12, lg: 16 }}
                    >
                      {formFields.map((field, index) => (
                        <Col
                          key={index}
                          className="gutter-row"
                          span={field.span || 4}
                        >
                          <Form.Item
                            name={[field.name]}
                            // name={[!isNil(docs[field.name]) ? field.name : null]}
                            // Apply rules based on your specific conditions
                            rules={field.rules}
                            value={field.value}
                            validateFirst
                          >
                            <FormField
                              key={field.name}
                              // Conditionally add a styled asterisk to the label based on the disabled state
                              label={
                                !field?.disabled && !isViewMode ? (
                                  <span>
                                    {field.label}{' '}
                                    <span className="color-asterisk">
                                      {'*'}
                                    </span>
                                  </span>
                                ) : (
                                  field.label
                                )
                              }
                              // Apply the disabled condition based on your specific requirements
                              disabled={field?.disabled ?? isViewMode}
                              {...omit(field, [
                                'span',
                                'rules',
                                'offset',
                                'disabled',
                                'label',
                              ])}
                              onChange={value =>
                                handleChange({
                                  key: field.name,
                                  type: field.type,
                                  event: value,
                                })
                              }
                            />
                          </Form.Item>
                        </Col>
                      ))}
                    </Row>

                    <Row gutter={{ xs: 4, sm: 8, md: 12, lg: 16 }}>
                      {formFields2.map((field, index) => {
                        return (
                          <Col
                            key={index}
                            className="gutter-row"
                            span={field.span}
                          >
                            <Form.Item
                              name={[field.name]}
                              rules={field.rules}
                              value={field.value}
                              validateFirst
                            >
                              <FormField
                                key={index}
                                disabled={field?.disabled ?? isViewMode}
                                {...omit(field, [
                                  'span',
                                  'rules',
                                  'offset',
                                  'disabled',
                                ])}
                                onChange={value =>
                                  handleChange({
                                    key: field.name,
                                    type: field.type,
                                    event: value,
                                  })
                                }
                              />
                            </Form.Item>
                          </Col>
                        );
                      })}
                    </Row>
                  </Col>
                </Row>
                {!viewMode ? (
                  <div className="mt-3">
                    {content_optional.map((item, index) => (
                      <Upload
                        item={item}
                        subFileCode={item.fileCode}
                        key={'docs_optional_' + index}
                        group={group}
                      />
                    ))}

                    <div className="mt-3">
                      {isBeneficiary(user?.groups) && (
                        <Upload
                          item={content_optional.find(
                            i => i.fileCode === 'otherDocs'
                          )}
                          subFileCode="otherDocs"
                          group={group}
                        />
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="mt-3">
                    <DownloadedItems
                      content={content_optional}
                      docs={flatDocs}
                    />

                    <div className="mt-3">
                      {isBeneficiary(user?.groups) && (
                        <Upload
                          item={content_optional.find(
                            i => i.fileCode === 'otherDocs'
                          )}
                          subFileCode="otherDocs"
                          key="otherDocs"
                          group={group || 'Documents'}
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
            </>
          }
        </Form>
      }
    </div>
  );
};

DocsInvestor.propTypes = {
  group: PropTypes.string.isRequired,
};

export default DocsInvestor;
